import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import Modal from 'react-bootstrap/Modal'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import DatePicker from "react-datepicker"
import { useHistory, Link } from 'react-router-dom'
import {
	extractEventParams,
	envAwarePost,
	capitalize,
	resizeFile,
	dateToYMD,
} from '../../util/util'
import { selectTrainerParam, selectClientsById, getAllClients } from '../users/usersSlice'
import useDirectUpload from '../../hooks/useDirectUpload' //DEPRECATED use useS3DirectUploadInstead
import useApiStatusEnvAwarePost from '../../hooks/useApiStatusEnvAwarePost'

const EventCreator = ({ location }) => {
	let dispatch = useDispatch()
	const history = useHistory()
	const statusEnvAwarePost = useApiStatusEnvAwarePost()
	const { selectedDate } = useSelector(state => (state.allEvents.selectedEventInfo))
	const trainerParam = useSelector(selectTrainerParam)
	//eventType = workout | task | nutrition
	//display = all | <event_id>
	//filter = client | favorite
	const {
		eventType,
		client_id,
		origin
	} = extractEventParams(location.search)
	/* --- local state --- */
	const [name, setName] = useState('')
	//default date to current date
	const [date, setDate] = useState(Boolean(selectedDate)?new Date(`${selectedDate}T00:00:00`):null)
	const [notes, setNotes] = useState('')
	const [link, setLink] = useState('')
	const [protocol, setProtocol] = useState('https://')
	const [buttonText, setButtonText] = useState('Start Building')
	const [status, setStatus] = useState('idle')
	const [thumbnailUrl, setThumbnailUrl] = useState(false)
	const [featureMediaUrl, setFeatureMediaUrl] = useState(false)
	const [showFeatureModal, setShowFeatureModal] = useState(false)
	const isClient = useSelector(state => state.users.current_user.account_type === "client")

	//direct upload stuff for full size image
	const {
		file: featureMedia,
		setUpload: setFeatureMedia,
		clearUpload: clearFeatureMedia,
		handleUpload: handleFeatureDirectUpload,
	} = useDirectUpload({ //DEPRECATED use useS3DirectUploadInstead
		success: url => {
			setFeatureMediaUrl(url)
		},
		fail: () => {
			alert('failed to save preview')
		}
	})

	const client = useSelector(state => selectClientsById(state, client_id))

	// make sure client is in state
	useEffect(() => {
		if (!client) {
			dispatch(getAllClients())
		}
	}, [client])

	//direct upload stuff for thumbnail 
	const {
		file: thumbnail,
		setUpload: setThumbnail,
		clearUpload: clearThumbnail,
		handleUpload: handleThumbnailDirectUpload,
	} = useDirectUpload({ //DEPRECATED use useS3DirectUploadInstead
		success: url => {
			setThumbnailUrl(url)
		},
		fail: () => {
			alert('failed to generate thumbnail')
		}
	})

	const clearPreview = () => {
		clearThumbnail()
		clearFeatureMedia()
	}

	//since we need to upload a feature & a thumb
	//and both of these saves happen async. we need
	//a helper function that will only save once we 
	//both
	useEffect(() => {
		if (!Boolean(featureMediaUrl) || !Boolean(thumbnailUrl)) return
		setButtonText('Saving')
		postCreateEvent({
			is_favorite: client_id === 'favorite' ? 1 : 0,
			feature_media: featureMediaUrl,
			link: `${protocol}${link}`,
			thumbnail: thumbnailUrl,
			action: 'createEvent',
			event_type: eventType,
			date: client_id === 'favorite' ? "1969-12-31" : date ? dateToYMD(date) : date,
			title: name,
			client_id,
			notes,
		})
	}, [featureMediaUrl, thumbnailUrl])

	const postCreateEvent = (postData) => {
		//prevent invalid links
		if (['http://', 'https://'].includes(postData.link)) {
			delete postData.link
		}
		statusEnvAwarePost('api/events/api/', postData, eventType, "create").then(res => {
			if (res.success === '1') {
				const event = res.data
				const event_id = event[`${eventType}_id`]
				const editorRoute = `/eventEditor/?event_id=${event_id}&event_type=AddOrEdit&eventType=${capitalize(eventType)}&client=${client_id}&origin=${origin}&${trainerParam}`
				history.push(editorRoute)
			} else {
				setButtonText('Start Building')
				setStatus('idle')
			}
		})
	}

	const handleStartBuilding = () => {
		setStatus('pending')
		//if feature media exists perform s3 upload flow then save event
		//else just save the event
		if (Boolean(featureMedia)) {
			setButtonText('Securely storing preview')
			//initiate S3 upload flow for full sized feature
			handleFeatureDirectUpload()
			//initiate S3 upload flow for thumbnail
			handleThumbnailDirectUpload()
		} else {
			setButtonText('Saving')
			let payload = {
				is_favorite: client_id === 'favorite' ? 1 : 0,
				link: `${protocol}${link}`,
				action: 'createEvent',
				event_type: eventType,
				title: name,
				client_id,
				notes,
			}

			payload.date = client_id === 'favorite' ? "1969-12-31" : date ? dateToYMD(date) : dateToYMD(new Date())

			postCreateEvent(payload)
		}
	}

	const handlePreviewChange = async e => {
		const file = e.target.files[0]
		setFeatureMedia(file)
		//compress file to width 128 and set thumbnail
		const compressedFile = await resizeFile(file, 80, 80)
		setThumbnail(new File([compressedFile], 'thumbnail.png', { type: "image/png", }))
	}
	//Helper fucntion which maps event type to the "Selector" get param for legacy routing
	const eventTypeToSelector = type => ['workout', 'task'].includes(type) ? `${capitalize(type)}s` : capitalize(type)

	let eventListUrl = isClient ? `/eventsView/?selector=${eventTypeToSelector(eventType)}` :
		`/eventsView?client=${client_id}&display=all&filter=client&selector=${eventTypeToSelector(eventType)}&${trainerParam}`

	return (
		<div id="containerDiv">
			<div className="mb-2">
				{!isClient && <div className="mb-2">
					<Link to={`/trainer?${trainerParam}`}>Client List</Link>
					<span className="mx-1">/</span>
					<Link to={eventListUrl}>

						{(client_id === "favorite") && 'Favorites'}
						{(client_id !== "favorite") && typeof client?.user_name !== 'undefined' && `${client?.user_name}'s ${eventTypeToSelector(eventType)}`}

					</Link>
					<span className="mx-1">/</span>
					<span> {capitalize(eventType)} Creator </span>
					<hr />
				</div>}
			</div>
			{/* --- General Info --- */}
			<Container className="bg-light p-3 rounded mb-3" style={{ border: '1px solid #ddd' }}>
				<Row className="mb-1">
					<Col>
						<span style={{ fontSize: '18px' }}>New {capitalize(eventType)} {client && `for ${client.user_name}`} </span>
						<hr />
					</Col>
				</Row>
				<Row className="mb-1">
					<Col sm="12" lg="2">
						<Form.Label>Name</Form.Label>
					</Col>
					<Col sm="12" lg="10">
						<Form.Control
							value={name}
							onChange={e => { setName(e.target.value) }}
							placeholder={`${capitalize(eventType)} Name`}
						/>
					</Col>
				</Row>
				{(client_id !== 'favorite') &&
					<Row className="mb-1">
						<Col sm="12" lg="2">
							<Form.Label>Date</Form.Label>
						</Col>
						<Col sm="12" lg="10" style={{ position: 'relative', zIndex: 10 }}>
							<DatePicker
								dateFormat="EEE, MMM d, yyyy"
								isClearable
								placeholderText="Select Date"
								onChange={newDate => { setDate(newDate) }}
								customInput={<Form.Control />}
								selected={date}

							/>
						</Col>
					</Row>
				}
				<Row className="mb-1">
					<Col sm="12" lg="2">
						<Form.Label>Notes</Form.Label>
					</Col>
					<Col sm="12" lg="10">
						<Form.Control
							style={{
								minHeight:'50px'
							}}
							value={notes}
							onChange={e => { setNotes(e.target.value) }}
							as="textarea"
							id="notesForm"
							placeholder={`${capitalize(eventType)} Notes`}
						/>
						{(notes !== "") &&
							<span
								style={{
									backgroundColor: "transparent",
									border: 0,
									outline: 0,
									padding: "0px 6px 0px 0px",
									position: "absolute",
									top: 0,
									right: "15px",
									height: "auto",
									display: "table-cell",
									verticalAlign: "middle",
									cursor: "pointer"
								}}
								onClick={(e) => { (document.getElementById("notesForm").value = ""); setNotes("") }}
							>&#x2612;</span>
						}
					</Col>
				</Row>
				<Row className="mb-1">
					<Col sm="12" lg="2">
						<Form.Label>Link</Form.Label>
					</Col>
					<Col sm="12" lg="10">
						<div className="input-group">
							<div className="input-group-prepend">
								<select className="input-group-text">
									<option>https://</option>
									<option>http://</option>
								</select>
							</div>
							<Form.Control
								onChange={e => { setLink(e.target.value) }}
								value={link}
								placeholder="optional"
							/>
						</div>
					</Col>
				</Row>
				<Row className="mb-1" style={{ marginTop: '7px' }}>
					<Col sm="12" lg="2">
						<Form.Label>
							Preview (optional)
							<OverlayTrigger overlay={
								<Tooltip>
									Image/gif to be displayed next to this {eventType}
								</Tooltip>
							}>
								<i className="fas fa-info-circle" />
							</OverlayTrigger>
						</Form.Label>
					</Col>
					<Col sm="12" lg="10">
						{/* <Form.File 
							onChange={handlePreviewChange}
							label={`${capitalize(eventType)} Preview`}
							custom
						/> */}

						<label htmlFor="newProfilePhoto" className="btn btn-secondary btn-sm fileinput-button">
							{`${capitalize(eventType)} Preview Image/Gif`}
						</label>

						<input style={{ display: "none" }} type="file" id="newProfilePhoto" name="profilePicFile"
							onChange={handlePreviewChange}
						// onChange={(e) => handleProfileImage(e, operationProfileImage)}
						// setAddModalImg(e.target.files[0]);
						// addImgRef.current = URL.createObjectURL(e.target.files[0]);
						/>
						{Boolean(featureMedia) &&
							<div className="mt-2">
								<small>{featureMedia.name}</small>
								<Button
									variant="outline-danger"
									onClick={clearPreview}
									className="ml-2"
									size="sm"
								>
									clear
								</Button>
							</div>
						}
						{Boolean(thumbnail) &&
							<div
								className="d-inline-flex flex-column align-items-center"
								onClick={() => { setShowFeatureModal(true) }}
								style={{ cursor: 'pointer' }}
								tabindex={0}
							>
								<small>Thumbnail Preview</small>
								<img
									style={{ width: '80px', display: 'block' }}
									src={URL.createObjectURL(thumbnail)}
								/>
							</div>
						}
					</Col>
				</Row>
				<Row>
					<Col>
						<Button
							disabled={status === 'pending'}
							onClick={handleStartBuilding}
							variant="outline-success"
							className="mt-2"
							block
						>
							<span>{buttonText}</span>
							{
								status === 'pending' &&
								<Spinner animation="border" size="sm" className="ml-2" />
							}
						</Button>
					</Col>
				</Row>
			</Container>
			{Boolean(featureMedia) &&
				<Modal
					onHide={() => { setShowFeatureModal(false) }}
					show={showFeatureModal}
					centered
				>
					<Modal.Header closeButton>
						Preview
					</Modal.Header>
					<Modal.Body>
						<img
							style={{ width: '100%', display: 'block' }}
							src={URL.createObjectURL(featureMedia)}
						/>
					</Modal.Body>
				</Modal>
			}
		</div>
	)
}

export default EventCreator